<div class="home">
  <div class="background-image flex items-center justify-center">
    <img
      src="assets/images/nlb_logo.svg"
      width="700"
      alt="NLB logo"
    />
  </div>
</div>
